import { createApiAction } from '@saucelabs/sl-util-redux';

import { getFilterParamsAdapter, getTimeFilterParams } from './../../api-adapter';
import * as api from './api';
import * as constants from './types';
import { LOAD_INIT_DATA } from './../general/types';
import { getFilters } from './../filters/operations';
import { getOrganization } from './../general/operations';

// get test names
export const getTestNames = createApiAction(
  constants.GET_TEST_NAMES,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      ...getFilterParamsAdapter(
        analytics.filters.get('filters').filter((value, key) => key === 'owners'),
      ),
      size: 100,
      ...payload,
    };

    return api.getTestNames(params);
  },
);

// get test metrics
export const getTestMetrics = createApiAction(
  constants.GET_TEST_METRICS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      ...payload,
    };

    return api.getTestMetrics(params);
  },
);

export const getPreviousTestMetrics = createApiAction(
  constants.GET_PREVIOUS_TEST_METRICS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(
        analytics.filters.get('selectedDateFilter'),
        Date.now() - (analytics.filters.getIn(['selectedDateFilter', 'value']) * 1000),
      ),
      ...payload,
    };

    return api.getTestMetrics(params);
  },
);

// get tests
export const getTests = createApiAction(
  constants.GET_TESTS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      size: 100,
      from: 0,
      ...payload,
    };
    return api.getTests(params, meta);
  },
);

export const loadInitData = createApiAction(
  LOAD_INIT_DATA,
  (payload, meta, dispatch) => Promise.all([
    dispatch(getFilters()),
    dispatch(getOrganization()),
    dispatch(getTestNames(payload)),
  ]),
);
